import React, { useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import AdminLayout from "../../../components/Admin/Layout";
import Tickets from "../../../components/Admin/SupportTicket/Tickets";

const pathPrefix = "/admin/tickets";

const AdminSupportTicketPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname !== pathPrefix) return;
    navigate(`${pathPrefix}/open`);
  }, [location.pathname]);

  return (
    <AdminLayout
      title={"Support Tickets"}
      tabs={[
        { id: 1, title: "All tickets", path: `${pathPrefix}/all` },
        { id: 2, title: "Open tickets", path: `${pathPrefix}/open` },
        { id: 3, title: "Closed tickets", path: `${pathPrefix}/closed` },
        { id: 4, title: "My tickets", path: `${pathPrefix}/my-tickets` },
      ]}
    >
      <Routes>
        <Route path="/all" element={<Tickets mode="all" />} />
        <Route path="/open" element={<Tickets mode="open" />} />
        <Route path="/closed" element={<Tickets mode="closed" />} />
        <Route path="/my-tickets" element={<Tickets mode="my" />} />
      </Routes>
    </AdminLayout>
  );
};

AdminSupportTicketPage.propTypes = {};

export default AdminSupportTicketPage;
